import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=21440cbf"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=21440cbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports